<template>
  <div v-if="isMobile" class="sonar-summary-badge__mobile-container">
    <InfoIcon class="sonar-summary-badge__info-icon" @click="showPopover" />
    <div v-if="showMobilePopover">
      <div class="sonar-summary-badge__modal__wrapper">
        <button
          class="dialog-modal__close sonar-dialog-modal__close"
          @click="hidePopover"
        >
          <XIcon class="dialog-modal__close--icon" />
        </button>
        <div>
          <div class="sonar-summary-badge__modal__dialog">
            <span class="sonar-summary-badge__title">Overview:</span>
            <div
              class="sonar-summary-badge__description"
              v-html="summary"
            ></div>
          </div>
          <div>
            <span class="sonar-summary-badge__title">Top Skills:</span>
            <div class="sonar-summary-badge__top-skill-container">
              <SonarTopSkillPill
                v-for="skill in topSkills"
                :key="skill"
                :topSkill="skill"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <v-popover
    v-else
    class="sonar-summary-badge"
    :trigger="'hover'"
    :popoverInnerClass="'sonar-summary-badge__popover--inner'"
    :placement="'right'"
    :auto-placement="true"
  >
    <InfoIcon class="sonar-summary-badge__info-icon" />
    <template slot="popover">
      <div class="sonar-summary-badge__popover">
        <div>
          <span class="sonar-summary-badge__title">Overview:</span>
          <div class="sonar-summary-badge__description" v-html="summary"></div>
        </div>
        <div>
          <span class="sonar-summary-badge__title">Top Skills:</span>
          <div class="sonar-summary-badge__top-skill-container">
            <SonarTopSkillPill
              v-for="skill in topSkills"
              :key="skill"
              :topSkill="skill"
            />
          </div>
        </div>
      </div>
    </template>
  </v-popover>
</template>

<script>
import { InfoIcon } from 'vue-feather-icons'
import SonarTopSkillPill from './SonarTopSkillPill.vue'
import { XIcon } from 'vue-feather-icons'

export default {
  name: 'SonarSummaryBadge',
  components: {
    InfoIcon,
    SonarTopSkillPill,
    XIcon,
  },
  props: {
    summary: {
      type: String,
      required: true,
    },
    topSkills: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      showMobilePopover: false,
    }
  },
  inject: ['getWindowWidth'],
  computed: {
    isMobile() {
      return this.getWindowWidth() < 768
    },
  },
  methods: {
    showPopover() {
      this.showMobilePopover = true
    },
    hidePopover() {
      this.showMobilePopover = false
    },
  },
}
</script>
<style lang="scss">
.popover-arrow {
  display: none;
}
</style>

<style lang="scss" scoped>
.popover-arrow {
  display: none;
}
.sonar-summary-badge {
  height: 24px;
  margin-left: 4px;
  &__mobile-container {
    display: flex;
    align-items: center;
    margin-left: 5px;
  }
  &__modal {
    &__wrapper {
      height: fit-content;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 300;
      display: flex;
      align-items: flex-end;
      border-radius: 20px 20px 0px 0px;
      background: var(--glass-mid-gray);
      background-color: var(--charcoal);
      padding: 30px 30px 41px 30px;
    }
    &__dialog {
      position: relative;
      background: transparent;
      width: 100%;
      color: var(--white);
      border-radius: 20px 20px 0px 0px;
      z-index: 300;
    }
  }

  &__title {
    color: var(--white);
    font-size: 14px;
    font-weight: bold;
  }
  &__description {
    color: var(--light-blue-gray);
    font-family: var(--font-book);
    font-size: 14px;
  }
  &__info-icon {
    width: 16px;
    height: 24px;
    right: -23px;
    color: var(--light-blue-gray);
    &:hover {
      color: var(--white);
    }
  }
  &__top-skill-container {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    width: 100%;
    margin-top: 5px;
  }
  .v-popover {
    height: auto !important;
    padding-top: 5px !important;
  }
  &__popover {
    width: 500px;
    min-height: 250px;
    padding: 20px;
    background: var(--mid-gray-gradient);
    border-radius: 4px;
    &--inner {
      display: flex;
    }
  }
}
</style>
